import React from 'react';
import { TrendingUpIcon, UserIcon, TrophyIcon, CalculatorIcon } from 'lucide-react';
export function About() {
  const features = [{
    icon: TrendingUpIcon,
    title: 'OPCIÓN FINANCIERA PARA TU CRECIMIENTO',
    description: 'Te ofrecemos una alternativa adecuada para ayudarte al crecimiento de tu negocio.'
  }, {
    icon: UserIcon,
    title: 'ASESORES FINANCIEROS',
    description: 'Proveemos asesoría para el financiamiento de tus activos con un esquema que te ayuda a ser más eficiente.'
  }, {
    icon: TrophyIcon,
    title: 'EJECUTIVOS CON +20 AÑOS DE EXPERIENCIA',
    description: 'Somos una empresa formada por expertos, con amplio conocimiento en financiamiento de activos.'
  }, {
    icon: CalculatorIcon,
    title: 'IDEAL PARA EMPRESAS Y PROFESIONISTAS',
    description: 'El producto que ofrecemos te brinda beneficios fiscales para tu empresa o actividad empresarial.'
  }];
  return <section id="acerca" className="py-20 bg-gray-50" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl font-light text-gray-900 mb-4" data-id="element-4">
            ¿Quiénes somos?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-5">
            Especialistas en Arrendamientos de Transporte, Maquinaria y Equipo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-6">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-lg p-8 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-7">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#2BA6DE]/10 mb-6" data-id="element-8">
                <feature.icon className="text-[#2BA6DE]" size={40} data-id="element-9" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-10">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-11">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}